<template>
  <div>
    <div v-loading="loading" class="pb-1 overflow-x-hidden">
      <!-- top -->
      <div class="px-5 py-3 shadow-sm">
        <h4 class="h3 text-muted font-weight-bold">Dashboard Management</h4>
        <span>You can create dashboard by clicking on the "Create Dashboard Link".</span>
        <el-link
          type="primary"
          href="/#/dashboard/create"
          class="btn btn-link text-primary"
          :underline="false"
          style="text-decoration: underline"
        >
          <strong>Create Dashboard</strong>
        </el-link>
        <div class="row align-items-center mt-4">
          <div class="col-md-6">
            <label class="h6 font-weight-bold d-block">Search Dashboard Title</label>
            <el-input v-model="searchParam" placeholder="Search" @input="performSearch">
              <svg-icon slot="prefix" icon-class="search" class="mt-2 py-1" />
            </el-input>
          </div>
        </div>
      </div>
      <div class="row px-5 mt-4" style="top: 75px">
        <section class="list">
          <DashboardBar title />
          <!-- <DashboardBar
            v-for="dashboard in filteredExistingDashboards"
            :key="dashboard.title"
            :params="dashboard"
            existing
            @dashboard-selected="handleDashboardSelection"
          /> -->
          <DashboardBar
            v-for="dashboard in filteredSavedDashboards"
            :key="dashboard.title"
            :params="dashboard"
            @dashboard-selected="handleDashboardSelection"
          />
          <el-alert v-if="error" type="error" show-icon center>
            <h6>{{ error }}</h6>
          </el-alert>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { existingDashboards } from "./utils/dashboardParams";
import DashboardBar from "./components/dashboardBar.vue";

export default {
  components: {
    DashboardBar,
  },
  data() {
    return {
      searchParam: "",
      existingDashboards,
      savedDashboards: [],
      loading: true,
      error: "",
    };
  },
  computed: {
    ...mapGetters(["indicators", "datasources", "dashboardError", "dashboards"]),
    filteredExistingDashboards() {
      return this.searchFilter(this.existingDashboards, this.searchParam);
    },
    filteredSavedDashboards() {
      return this.searchFilter(this.savedDashboards, this.searchParam);
    },
  },
  watch: {
    dashboards(boards) {
      this.savedDashboards = this.mapDashboards(boards);
    },
    indicators() {
      this.savedDashboards = this.mapDashboards(this.dashboards);
    },
    datasources() {
      this.savedDashboards = this.mapDashboards(this.dashboards);
    },
  },
  async mounted() {
    if (!this.dashboards.length || this.dashboardError.dashboards) await this.loadDashboards();
    if (!this.indicators.length || this.dashboardError.indicators) this.loadIndicators();
    if (!this.datasources.length || this.dashboardError.datasources) this.loadDatasources();
    const { indicators, datasources, dashboards } = this.dashboardError;
    if (indicators || datasources || dashboards) {
      this.error = "Unable to load dashboards!";
    } else {
      this.savedDashboards = this.mapDashboards(this.dashboards);
    }
    this.loading = false;
  },
  methods: {
    ...mapActions("dashboard", ["loadIndicators", "loadDatasources", "loadDashboards"]),
    ...mapActions("activity", ["logActivity"]),
    searchFilter(list, param) {
      if (!list) return [];
      return list.filter((item) => item.name.toLowerCase().includes(param.toLowerCase()));
    },
    cap(text) {
      return text
        .split("_")
        .map((word) => word.at(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    mapDashboards(dashboards) {
      return dashboards.map((dashboard) => ({
        id: dashboard.id,
        // name: dashboard.name_of_dashboard,
        name: dashboard.title,
        // category: this.cap(dashboard.category),
        category: dashboard.title,
        // created: new Date(dashboard.created || "01/02/2024").toLocaleDateString(),
        created: new Date(dashboard.created_at).toLocaleDateString(),
        // updated: new Date(
        //   dashboard.updated || dashboard.created || "01/02/2024"
        // ).toLocaleDateString(),
        updated: new Date(dashboard.created_at).toLocaleDateString(),
        indicator:
          this.indicators.find((ind) => ind.id === (dashboard.initialIndicator || 0))?.full_name ||
          "...",
        datasource:
          this.datasources.find((dash) => dash.id === (dashboard.initialDataSource || 0))
            ?.datasource || "...",
        link: `https://msdat.fmohconnect.gov.ng/dashboard/${dashboard.name}`,
      }));
    },
    performSearch() {
      this.logActivity({
        type: "SEARCH_DASHBOARD",
        userId: this.$store.state.user.id,
        timestamp: new Date().toISOString(),
        searchParam: this.searchParam,
      });
    },
    handleDashboardSelection(dashboard) {
      this.logActivity({
        type: "VIEW_DASHBOARD",
        userId: this.$store.state.user.id,
        timestamp: new Date().toISOString(),
        dashboardId: dashboard.id,
        dashboardName: dashboard,
        category: dashboard.category,
      });
    },
  },
};
</script>

<style scoped>
section.list {
  width: 100%;
  overflow: auto;
  padding: 0 30px 20px;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
</style>
